import type { ReactNode } from 'react'

// 9:16 手机框（340×604），内部填满场景预览。
export default function PhoneFrame({ children }: { children: ReactNode }) {
  return (
    <div className="phone-frame">
      <div className="phone-notch" />
      <div className="phone-screen preview-screen">{children}</div>
    </div>
  )
}
